import { FC, useEffect, useState } from 'react'
import { getInitials, getStyleByIndex, UrlBuilder, UrlParamReplace } from 'app/helpers/MiscUtils'
import { MenuInner } from './MenuInner'
import { toAbsoluteUrl } from '_metronic/helpers'
import { useAuth } from 'app/context/auth-context'

import { VideoSessionStatus } from 'app/API'
import { useAppContext } from "app/context/app-context";
import { AlertModal } from 'app/modules/shared/modals/AlertModal';
import { HeaderNotificationPanel } from './HeaderNotificationPanel';
import { Roles } from 'app/types'
import moment from 'moment'
import { RxSubscription } from 'app/RxSubscriptions'
import { Subscription } from 'rxjs'
import { Link } from 'react-router-dom'
import JobFairSelector from './JobFairSelector'
import useWebSocket from 'app/hooks/useWebsocket'
import { JobFairStatusComponent } from './JobFairStatusComponent'
import { JSRoutes } from 'app/modules/job-seeker/JSPage'
import { AdminMenuItems } from './AdminMenuItems'

const Header: FC = () => {
  const { user } = useAuth();

  const [showDesktopOnlyAlert, setShowDesktopOnlyAlert] = useState<boolean>(false);
  const isSocketConnected = true;
  useWebSocket();
  const [showOfflinePopup, setShowOfflinePopup] = useState<boolean>(false);
  const { jobFair } = useAppContext()
  useEffect(() => {
    const isMobileOrTablet = function () {
      let check = false;
      (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor);
      return check;
    };

    if (isMobileOrTablet() === true) {
      setShowDesktopOnlyAlert(true);
    }
  }, []);

  useEffect(() => {
    let timeOutRef: NodeJS.Timeout | undefined = undefined;
    console.info(`${moment().format('HH:mm:ss')} - Custom Socket Status - ${isSocketConnected ? 'Online' : 'Offline'}`);
    if (!isSocketConnected) {
      timeOutRef = setTimeout(() => {
        setShowOfflinePopup(true);
      }, 10000);
    }
    else {
      setShowOfflinePopup(false);
    }
    return () => {
      if (timeOutRef) {
        clearTimeout(timeOutRef);
        console.info(`${moment().format('HH:mm:ss')} - ShowOfflinePopup Timeout cleared`);
      }
    }
  }, [isSocketConnected]);

  const [isInterviewInProgress, setIsInterviewInProgress] = useState<boolean>(false);

  useEffect(() => {
    let subscription: Subscription;
    if (user?.roles?.includes(Roles.Applicant)) {
      subscription = RxSubscription.onChangeInterviewSessionByCandidateIdObservable().subscribe(changeEvent => {
        setIsInterviewInProgress(changeEvent?.value?.status === VideoSessionStatus.IN_PROGRESS);
      });
    }
    else if (user?.roles?.includes(Roles.Recruiter)) {
      subscription = RxSubscription.onChangeInterviewSessionByRecruiterIdObservable().subscribe(changeEvent => {
        setIsInterviewInProgress(changeEvent?.value?.status === VideoSessionStatus.IN_PROGRESS);
      });
    }
    return () => {
      if (subscription)
        subscription.unsubscribe();
    };
  }, [user]);

  return (
    <header>
      <div className="container-fluid">
        <div className="flex">
          <div className="logo">
            <a href="#"><img src={toAbsoluteUrl('/media/logos/logo.png')} alt="Video JobFair" /></a>
          </div>
          {user?.roles?.includes(Roles.Admin) ? <></> : <>{user?.roles?.includes(Roles.Applicant) ? <JobFairStatusComponent /> :
            <JobFairSelector />}</>
          }
          <nav>
            {user?.roles?.includes(Roles.Admin) ? <ul id="menu">
              <AdminMenuItems />
            </ul> :
              <ul id="menu" className={isInterviewInProgress || !jobFair ? 'vjfpDisabled' : ''}>
                <MenuInner />
              </ul>}
            {/* Notifications */}
            {!user?.roles?.includes(Roles.Admin) && <HeaderNotificationPanel />}
            {/* User Profile */}
            <div className="userProfile">
              <a className="menu-dropdown" data-kt-menu-trigger="click" data-kt-menu-attach="parent"
                data-kt-menu-placement="bottom-end" data-kt-menu-flip="bottom">
                {user?.avatar ?
                  <img src={toAbsoluteUrl(user?.avatar)} />
                  :
                  <div className="symbol symbol-50px symbol-circle">
                    <div className={"symbol-label fs-3 fw-bold bg-" + getStyleByIndex(0) + " text-inverse-" + getStyleByIndex(0)}>{getInitials(user?.firstName, user?.lastName)}</div>
                  </div>
                }
              </a>
              <div className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px"
                data-kt-menu="true">
                <div className="menu-item px-3">
                  <div className="menu-content d-flex align-items-center px-3">
                    <div className="symbol symbol-50px me-5">
                      <div className={"symbol-label fs-3 fw-bold bg-" + getStyleByIndex(2) + " text-inverse-" + getStyleByIndex(2)}>{getInitials(user?.firstName, user?.lastName)}</div>

                    </div>
                    <div className="d-flex flex-column">
                      <div className="fw-bolder d-flex align-items-center fs-5 lh22" title={user?.roles?.join(',')}>{user?.firstName} {user?.lastName}</div>
                      <div
                        className="fw-bold text-muted fs-7">{user?.email}
                      </div>
                    </div>
                  </div>
                </div>
                {user?.roles?.includes(Roles.Applicant) &&
                  <div className="menu-item px-5">
                    <Link className="menu-link px-5" to={UrlParamReplace(JSRoutes.Profile)}><span className="menu-text">My Profile</span></Link>
                  </div>
                }
                <div className="separator my-2"></div>

                <div className="menu-item px-5">
                  <Link className="menu-link px-5" to={'/logout'}><span className="menu-text">Sign out</span></Link>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </div >
      <AlertModal show={showDesktopOnlyAlert} title="Mobile not yet supported" onOK={() => { setShowDesktopOnlyAlert(false); }} >
        This platform does not currently support mobile or tablets. Please login using a desktop or laptop computer.
      </AlertModal>
      <AlertModal show={showOfflinePopup} title="Connection interrupted" okText='🗘 Reload now' onOK={() => { window.location.reload(); }} >
        Please wait while we try connecting again. Please reload if this is taking long to connect again
      </AlertModal>
    </header >
  )
}

export { Header }